import { render, staticRenderFns } from "./result.vue?vue&type=template&id=0a6d090e&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports